import VSubheader from './VSubheader'

export default {
  VSubheader
}



// WEBPACK FOOTER //
// ./src/components/subheaders/index.js